try {
    $(document).ready(function () {
        $('button[type=submit][data-button-action=add-to-cart]').click(function () {
            $(this).addClass('clicked-btn');
        });
    });

} catch (error) {
    console.error(error);
}